
<div class="sidenav">
  <div class="login-main-text">
    <img src="../../assets/images/white-logo.png"/>

  </div>
</div>
<div class="main ">
  <div class="col-md-12 col-sm-12">

    <div class="login-form text-center">
      <h3 class="primary-color mb-5">مرحبا بك مجدداً .. </h3>
      <div class="alert alert-danger" role="alert" *ngIf="showErr">
        البريد الإلكتروني أو كلمة المرور غير صحيحة
      </div>
      <form [formGroup]="data" class="col-md-6 text-center container"  autocomplete="off"  >

        <p>
          <input id="input" autocomplete="false" formControlName="email" type="email" required />
          <label for="input" alt="البريد الإلكتروني" placeholder="البريد الإلكتروني"></label>
        </p>
        <p>
          <input id="input2" autocomplete="false" formControlName="password" type="password" required />
          <label for="input2" alt="كلمة المرور" placeholder="كلمة المرور"></label>
        </p>
        <button type="button" [disabled]="!data.valid" (click)="login()" class="btn radius-16  background-blue-g pr-5 pl-5">تسجيل دخول</button>
      </form>
    </div>
  </div>
</div>
